import { gql } from '@apollo/client';

export default gql`
  mutation UnassignSquadShifts($input: UnassignSquadShiftInput!) {
    unassignSquadShifts(input: $input) {
      count
    }
  }
`;
